import React from 'react';

/**
 * PiPauseBigStroke icon from the stroke style in media category.
 */
interface PiPauseBigStrokeProps extends React.SVGProps<SVGSVGElement> {
	size?: number;
	color?: string;
	className?: string;
	ariaLabel?: string;
}

export default function PiPauseBigStroke({
	size = 24,
	color,
	className,
	ariaLabel = 'pause-big icon',
	...props
}: PiPauseBigStrokeProps): JSX.Element {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={{ color: color || 'currentColor' }}
			role="img"
			aria-label={ariaLabel}
			{...props}
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M6 6.8c0-.98 0-1.47.191-1.844a1.75 1.75 0 0 1 .765-.765C7.33 4 7.82 4 8.8 4h.4c.98 0 1.47 0 1.844.191.329.168.597.436.765.765.191.374.191.864.191 1.844v10.4c0 .98 0 1.47-.191 1.844a1.75 1.75 0 0 1-.765.765C10.67 20 10.18 20 9.2 20h-.4c-.98 0-1.47 0-1.844-.191a1.75 1.75 0 0 1-.765-.765C6 18.67 6 18.18 6 17.2zm8 0c0-.98 0-1.47.191-1.844a1.75 1.75 0 0 1 .765-.765C15.33 4 15.82 4 16.8 4h.4c.98 0 1.47 0 1.844.191.329.168.597.436.765.765.191.374.191.864.191 1.844v10.4c0 .98 0 1.47-.191 1.844a1.75 1.75 0 0 1-.765.765C18.67 20 18.18 20 17.2 20h-.4c-.98 0-1.47 0-1.844-.191a1.75 1.75 0 0 1-.765-.765C14 18.67 14 18.18 14 17.2z"
				fill="none"
			/>
		</svg>
	);
}
